import type {
    DocumentPartsResponse,
    InlineRelationsResponse,
} from "../types";
import {PanelDocumentPartsLEGACY} from "../legacy/PanelDocumentPartsLEGACY";
import {Feature, useFeature} from "../../../featureFlags/featureFlags";
import type {PanelItem} from "./PanelContext";
import {PanelDocumentParts} from "./PanelDocumentParts";
import {PanelInlineRelations} from "./PanelInlineRelations";

export const PanelContent = ({item}: {item: PanelItem}) => {
    const {enabled: newContentDesign} = useFeature(Feature.NewContentDesign);

    if (item.fetchType === "documentParts") {
        const DocumentPartsComponent = newContentDesign
            ? PanelDocumentParts
            : PanelDocumentPartsLEGACY;
        return (
            <DocumentPartsComponent
                data={item.data as DocumentPartsResponse}
            />
        );
    }

    if (item.fetchType === "inlineRelations") {
        return (
            <PanelInlineRelations
                data={item.data as InlineRelationsResponse}
                title={item.label}
            />
        );
    }

    return null;
};
